import { render, staticRenderFns } from "./TermLink.vue?vue&type=template&id=83215bb6"
import script from "./TermLink.vue?vue&type=script&lang=js"
export * from "./TermLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports